import { render, staticRenderFns } from "./border.vue?vue&type=template&id=3c196f88&scoped=true&"
import script from "./border.vue?vue&type=script&lang=js&"
export * from "./border.vue?vue&type=script&lang=js&"
import style0 from "./border.vue?vue&type=style&index=0&id=3c196f88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c196f88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/work/jiangxi/fed-sd-visual-web-static/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c196f88')) {
      api.createRecord('3c196f88', component.options)
    } else {
      api.reload('3c196f88', component.options)
    }
    module.hot.accept("./border.vue?vue&type=template&id=3c196f88&scoped=true&", function () {
      api.rerender('3c196f88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/border.vue"
export default component.exports